<template>
  <div class="container">
    <ClcmsMenu @productsSelect="productsSelect"/>
    <div class="viewBody" >
      <div data-aos="fade-up">
        <div class="eh-ibs">
          <span class="eh-ibs-title">EH-CLCMS细胞全生命周期整体解决方案</span>
        </div>
        <div class="other-title">
          <img src="../../assets/img/products/qxzn/over.png">
        </div>
      </div>
      <div class="title" data-aos="fade-up">
        EH-CLCMS细胞全生命周期整体解决方案通过顶层设计、规划建设、信息系统和专业化运营服务等，实现细胞从采集到临床应用的数字化、智能化全流程管理。该方案贯穿检测、制备、质控、存储、调配等关键环节，运用信息平台进行可视化监控和智能决策，构建符合GMP要求的标准化工作流，全面保障细胞产品的质量与安全。
      </div>
      <div class="body-card">
        <div class="body-card-row" data-aos="zoom-in-up">
          <div v-for="(item,index) in list" :key="index" :class="index=='0'?'body-card-row-card':'body-card-row-card card-interval'">
            <div class="body-card-row-card-top flex-center">
              <div class="body-card-row-card-top-rectangle">
              </div>
            </div>
            <div class="body-card-row-card-title flex-center">{{item.title}}</div>
            <div class="body-card-row-card-body">
              <div class="body-card-row-card-body-row" v-for="(k,i) in item.children" :key="i">
                <div class="body-card-row-card-body-row-drop"></div>
                <div class="body-card-row-card-body-row-word">{{k}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="body-card-row" style="margin-top: 10px" data-aos="zoom-in-up">
          <div v-for="(item,index) in list1" :key="index" :class="index=='0'?'body-card-row-card':'body-card-row-card card-interval'">
            <div class="body-card-row-card-top flex-center">
              <div class="body-card-row-card-top-rectangle">
              </div>
            </div>
            <div class="body-card-row-card-title flex-center">{{item.title}}</div>
            <div class="body-card-row-card-body">
              <div class="body-card-row-card-body-row" v-for="(k,i) in item.children" :key="i">
                <div class="body-card-row-card-body-row-drop"></div>
                <div class="body-card-row-card-body-row-word">{{k}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="body-img" data-aos="slide-left">
        <div class="body-img-top">
          <div class="body-img-top-title">Ecell细胞全生命周期信息管理系统</div>
        </div>
        <div class="body-img-row">
          <div style="width: 416px;color: white;text-indent: 32px;line-height: 30px;font-size: 15px;margin-top: 60px;margin-left: 76px">
            Ecell细胞全生命周期信息管理系统是基于细胞全生命周期的干细胞资源库大数据管理平台，该系统包含多个子系统，用于管理细胞采集、检测、制备、质控、运输、存储、放行、销毁等各个阶段的数据，360度全周期贯穿从细胞采集到应用等的全流程，保障细胞制剂质量和细胞治疗应用的规范化，满足细胞实验研究与临床应用管理需求。
          </div>
          <img src="../../assets/img/products/cell/c.png" width="469" style="margin-left: 12px">
        </div>
      </div>
      <div class="body-part" style="margin-top: 95px" data-aos="fade-left">
        系统框架
      </div>
      <div class="body-row" data-aos="zoom-in-up">
        WEB页面
      </div>
      <div class="body-row-title" data-aos="zoom-in-up">展示层</div>
      <div class="body-row-card" data-aos="zoom-in-up">
        <div class="body-row-card-left">
          <div class="body-row-card-left-top">
            <div class="body-row-card-left-top-flex">
              <div class="body-row-card-left-top-flex-div" v-for="(item,i) in list2" :key="i">{{item}}</div>
            </div>
            <div class="body-row-card-left-top-title">应用层</div>
          </div>
          <div class="body-row-card-left-bottom">
            <div class="flex-lefts">
              <div style="display: flex">
                <div class="flex-lefts-div">身份认证</div>
                <div class="flex-lefts-div" style="margin-left: 3px">权限管理</div>
              </div>
              <div style="display: flex;margin-top: 2px">
                <div class="flex-lefts-div">数据备份</div>
                <div class="flex-lefts-div" style="margin-left: 3px">报警设置</div>
              </div>

            </div>
            <div class="flex-rights">基础层</div>
          </div>
        </div>
        <div class="body-row-card-right">
          <div style="margin-left: 10px;margin-top: 11px">
            <div class="body-row-card-right-div">实验室资源管理系统</div>
            <div class="body-row-card-right-div">干细胞临床研究信息管理系统</div>
            <div class="body-row-card-right-div">细胞制备过程数据管理系统</div>
            <div class="body-row-card-right-div">细胞质量验收管理系统</div>
            <div class="body-row-card-right-div">成体细胞综合存储库信息系统样本流转子系统</div>
          </div>
          <div class="body-row-card-right-title"> 应用层</div>
        </div>
      </div>
      <div class="body-row" style="background-color: #eaeaea;" data-aos="zoom-in-up">
        <div class="body-row-div" style="margin-right: 61px">关系型数据库</div>
        <div class="body-row-div">文档数据库</div>
      </div>
      <div class="body-row-title" data-aos="zoom-in-up">数据层</div>
      <div class="body-part" style="margin-top: 95px" data-aos="fade-left">
        功能模块
      </div>
      <div style="padding:80px 40px" data-aos="zoom-in-up">
        <img src="../../assets/img/products/cell/f.png" width="988"/>
      </div>
      <div class="body-title" style="width: 280px;display: flex;align-items: center;justify-content: center" data-aos="zoom-in-up">
        <div class="body-title-word">细胞资源库建设整体规划</div>
      </div>
      <div class="body-dec" style="text-indent: 32px" data-aos="fade-left">
        上海唐颐信息技术有限公司为细胞资源库建设提供整体解决方案，服务涵盖建设方案咨询、详细规划设计等。我们注重根据实际运营需求进行设计，能够因地制宜为客户提供既符合标准化要求，又兼具个性化设计的细胞资源库设计方案。我们的专业技术支持，将帮助客户建立管理精细化和操作规范化的细胞资源库。
      </div>
      <div data-aos="zoom-in-up">
        <img src="../../assets/img/products/cell/b.png"/>
      </div>
      <div class="body-title" style="width: 172px;display: flex;align-items: center;justify-content: center;margin-top: 86px"  data-aos="zoom-in-up">
        <div class="body-title-word">设备/耗材选型咨询服务</div>
      </div>
      <div class="body-list-card" style="margin-top: 44px" data-aos="zoom-in-up">
        <div class="card-body card-first">存储设备</div>
        <div class="card-body card-other">二氧化碳培养箱</div>
        <div class="card-body card-other">恒温恒湿箱</div>
        <div class="card-body card-other">生化培养箱</div>
        <div class="card-body card-other">离心机</div>
      </div>
      <div class="body-list-card" style="margin-top: 16px" data-aos="zoom-in-up">
        <div class="card-body card-first">超净工作台</div>
        <div class="card-body card-other">生物安全柜</div>
        <div class="card-body card-other">组织研磨仪</div>
        <div class="card-body card-other">恒温水槽</div>
        <div class="card-body card-other">细胞摇瓶</div>
      </div>
      <div class="body-list-card" style="margin-top: 16px" data-aos="zoom-in-up">
        <div class="card-body card-first">细胞培养板</div>
        <div class="card-body card-other">培养皿</div>
        <div class="card-body card-other">T型瓶</div>
        <div class="card-body card-other">移液管</div>
        <div class="card-body card-other">……</div>

      </div>
<!--      <div class="body-title"  style="width: 279px;display: flex;align-items: center;justify-content: center" data-aos="fade-up">-->
<!--        <div class="body-title-word">AABB认证咨询培训服务</div>-->
<!--      </div>-->
<!--      <div class="low-title"  data-aos="fade-up">AABB制定的基准</div>-->
<!--      <div class="low-desc"  data-aos="fade-up">AABB制定的基准，包含有相关联的法规，科学的根据，美国食品医药品局(FDA)及欧盟订定的医药品制造管理规则，按照(GMP)和<br/>质量及量测控制原则被慎重实行。2007年更加将这些的规则和国际标准化组织跟(ISO)定的国际质量管理控制规则(ISO9000系列)的条文<br/>合并纳入进行，作为实际上的全世界最慎重的国际基准。</div>-->
<!--      <div class="low-title" style="margin-top: 60px"  data-aos="fade-up">基准的内容</div>-->
<!--      <div class="low-desc"  data-aos="fade-up">基准的内容:从文件管理、设备管理等的营运管理，工作检验的内容等技术方面，工作人员的教育训练和物品进料经过质量及量测管<br/>理体制的所有全方位性面性。</div>-->
<!--      <div class="low-desc" style="margin-top: 0" data-aos="fade-up">另一方面又需定期性的内部监查稽核和二年由于一次的AABB监查员的外部监查稽核义务方能被认证许可，唯有真正的全方位的管理<br/>体制持续性地被维持作为重要的点被审查。</div>-->
<!--      <div style="margin-top: 36px;margin-left: 12px" data-aos="zoom-in-up">-->
<!--        <img src="../../assets/img/products/cell/a.png"/>-->
<!--      </div>-->
<!--      <div class="body-title" style="width: 259px;display: flex;align-items: center;justify-content: center" data-aos="fade-up">-->
<!--        <div class="body-title-word">GMP标准认证培训服务</div>-->
<!--      </div>-->
<!--      <div class="low-title"  data-aos="fade-up">GMP认证</div>-->
<!--      <div class="low-desc"  data-aos="fade-up">中国卫生部于1995年7月11日下达卫药发（1995）第35号"关于开展药品GMP认证工作的通知"。药品GMP认证是国家依法对药品<br/>生产企业（车间）和药品品种实施GMP监督检查并取得认可的一种制度。虽然国际上药品的概念包括兽药，但只有中国和澳大利亚等少<br/>数几个国家是将人用药GMP和兽药GMP分开的。</div>-->
<!--      <div class="low-desc"  style="margin-top: 0"  data-aos="fade-up">药品GMP认证分为国家和省两级进行，根据《中华人民共和国药品管理法实施条例》的规定，省级以上人民政府药品监督管理部门<br/>应当按照《药品生产质量管理规范》和国务院药品监督管理部门规定的实施办法和实施步骤，组织对药品生产企业的认证工作；符合《<br/>药品生产质量管理规范》的，发给认证证书。其中，生产注射剂、放射性药品和国务院药品监督管理部门规定的生物制品的药品生产企<br/>业的认证工作，由国务院药品监督管理部门负责。</div>-->
      <div class="body-title" style="width: 131px;display: flex;align-items: center;justify-content: center" data-aos="fade-up">
        <div class="body-title-word">综合优势</div>
      </div>
      <div class="low-title"  data-aos="fade-up">强大的行业资源与影响力</div>
      <div style="margin-top: 36px;margin-left: 12px" data-aos="zoom-in-up">
        <img src="../../assets/img/products/cell/g.png"/>
      </div>
      <div class="blue-back" data-aos="zoom-in-up">
        <div class="low-title" style="margin-top: 0"  data-aos="fade-up">先进的全生命周期管理系统</div>
        <div style="margin-top: 32px;margin-left: 150px">
          <img src="../../assets/img/products/cell/z.png" width="1000px"/>
        </div>

      </div>
      <div class="foot-div" data-aos="zoom-in-up">
        <div class="foot-div-img">
          <img src="../../assets/img/products/cell/e.png" height="347px"/>
        </div>
        <div class="foot-div-desc">
          <div class="foot-div-desc-title">丰富的研发与项目实施经验</div>
          <div class="foot-div-desc-li">
            <div class="foot-div-desc-li-rir"></div>
            <div class="foot-div-desc-li-word">上海市东方医院干细胞临床研究信息管理平台</div>
          </div>
          <div class="foot-div-desc-li">
            <div class="foot-div-desc-li-rir"></div>
            <div class="foot-div-desc-li-word">国家泌尿生殖系肿瘤研究中心细胞工程实验室</div>
          </div>
          <div class="foot-div-desc-li">
            <div class="foot-div-desc-li-rir"></div>
            <div class="foot-div-desc-li-word">中国人民解放军总医院医学创新研究部临床生物样本中心细胞库</div>
          </div>
          <div class="foot-div-desc-li">
            <div class="foot-div-desc-li-rir"></div>
            <div class="foot-div-desc-li-word">上海生物样本库（原“上海张江生物银行“）细胞库</div>
          </div>
          <div class="foot-div-desc-li">
            <div class="foot-div-desc-li-rir"></div>
            <div class="foot-div-desc-li-word">中国人民解放军海军军医大学第一附属医院</div>
          </div>
        </div>
      </div>
      <div class="body-title" data-aos="fade-up" style="width: 109px;display: flex;align-items: center;justify-content: center;margin-top: 0px">
        <div class="body-title-word">视频介绍</div>
      </div>
      <div style="width: 1000px;height:auto;margin: 10px">
        <video style="width: 100%" controls   name="media" id="video"  poster="../../assets/mp4/2.png">
          <source  src="../../assets/mp4/2.mp4" type='video/mp4' />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import ClcmsMenu from "../../components/ClcmsMenu";
export default {
  name: "cellNew",
  components:{
    ClcmsMenu
  },
  data(){
    return{
      list:[
        {title:'顶层设计',children:['战略定位', '组织架构', '工作流程', '标准规范', '安全管理']},
        {title:'信息管理系统',children: [
            '细胞全生命周期信息管理系统',
            '细胞采集系统',
            '细胞筛查系统',
            '储户CRM管理系统',
            '细胞资源运输监控管理平台',
            '细胞资源大数据管理平台',
          ]},
        {title:'场地布局规划咨询',children: [
            '功能区规划',
            '空间设计',
            '通风系统',
            '消防和灭火系统',
            '配电系统和应急电源',
            '安防和监控系统',
            '信息基础设施',
            '数据备份系统'
          ]}
      ],
      list1:[
        {title:'质量和能力建设',children:[
            "质量管理体系",
            "标准化操作流程",
            "规范化管理制度",
            "过程控制和优化",
            "质量检查与监控",

          ]},
        {title:'设备/耗材选型咨询服务',children:[
            "设备选型（存储量/预算/处理技术）",
            "设备全生命周期管理",
            "耗材选型（样本类型/处理流程）",
            "耗材采购及库存管理"
          ]},
        {title:'相关服务',children:[
            // "认证咨询培训服务",
            // "标准认证培训服务",
            // "人类遗传资源管理行政审批服务",
            "细胞资源库运营服务",
              // "细胞资源库第三方存储服务"
          ]}
      ],
      list2:['试剂耗材管理','用户管理','系统管理','立项管理','实验方案','质检方案','制备实验','质检实验','质检报告','样本流转管理','空间位置管理','……']
    }
  },
  methods:{
    productsSelect(src){
      this.$emit('productsSelect',src)
    }
  }
}
</script>

<style scoped lang="less">
.foot-div{
  width: 100%;
  height: 375px;
  padding-top: 71px;
  display: flex;
  &-img{
    margin-left: 200px;
  }
  &-desc{
    margin-left: 50px;
    height: 347px;
    padding-top: 60px;
      &-title{
        text-indent: 20px;
     font-family: SourceHanSansCN-Medium;
     font-size: 20px;
     font-weight: normal;
     font-stretch: normal;
     line-height: 23px;
     letter-spacing: 2px;
     color: #262626;
   }
    &-li{
      display: flex;
      align-items: center;
      margin: 15px 0;
      //justify-content: center;
      &-rir{
        width: 6px;
        height: 6px;
        margin-right: 15px;
        background-color: #006efd;
        transform: rotate(45deg);
      }
      &-word{
        font-family: SourceHanSansCN-Normal;
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #000000;
      }
    }
  }
}
.blue-back{
  width: 100%;
  height: 721px;
  margin-top: 100px;
  padding-top: 54px;
  background-color: #f4f7fe;
  .row{
    width: 100%;
    display: flex;
    .row-rir{
      width: 101px;
      height: 102px;
      position: relative;
      text-align: center;
      background-color: #ffffff;
      border-radius: 50%;
    }
    .row-desc{
      font-family: SourceHanSansCN-Medium;
      font-size: 19px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 43px;
      letter-spacing: 2px;
      color: #006efd;
    }
  }
  .rir{
    width: 557px;
    height: 524px;
    border-radius: 50%;
    border: 10px solid #F0F4FE;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.container{
  width: 100%;
  margin-top:126px;
  padding-left: 20%;
  display: flex;
  position: relative;
}
.viewBody{
  flex: 1;
  margin-left: 50px;
  height: auto;
}
.eh-ibs {
  width: 100%;
  display: flex;
  height: 28px;
  &-title{
    margin-left: 208px;
    font-family: SourceHanSansCN-Normal;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 2px;
    color: #ed1c24;
  }
}
.other-title{
  width: 246px;
  margin-left: 390px;
  height: 38px;
  font-family: Dead-Island;
  font-size: 44px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #dfefff;
  white-space: nowrap;
  position: relative;
  top:-10px
}
.title{
  width: 985px;
  height: 60px;
  font-family: SourceHanSansCN-Regular;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 23px;
  letter-spacing: 1px;
  color: #000000;
  text-align: justify-all;
  margin-top: 37px;
  text-indent: 40px;
}
.body-card{
  width:100%;
  margin-top: 54px;
  height:auto;
  &-row{
    display: flex;
    &-card{
      width: 226px;
      height: 283px;
      background-image: linear-gradient(135deg,
      #ffffff 0%,
      #f1f7ff 0%,
      #e3efff 0%,
      #ffffff 100%);
      &-top{
        width: 100%;
        height: auto;
        &-rectangle{
          width: 39px;
          height: 5px;
          background-color: #c8e0ff;
        }
      }
      &-title{
        width: 100%;
        margin-top: 15px;
        margin-bottom: 25px;
        height: 19px;
        font-family: SourceHanSansCN-Medium;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 23px;
        letter-spacing: 2px;
        color: #000000;
      }
      &-body{
        width: 100%;
        &-row{
          width: 300px;
          height: 26px;
          display: flex;
          align-items: center;
          &-drop{
            width: 7px;
            height: 7px;
            background: #0b96fa;
            transform:rotate(45deg);
            margin-left: 21px;
            margin-right: 11px;
          }
          &-word{
            font-family: SourceHanSansCN-Normal;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 26px;
            letter-spacing: 1px;
            color: #000000;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
.body-img{
  width: 100%;
  margin-top: 16px;
  height: auto;
  background-color: #006efd;
  padding-top: 58px;
  padding-bottom: 85px;
  &-top{
    width: 100%;
    height: 29px;
    &-title{
      width: 490px;
      height: 33px;
      background-color: #ffffff;
      font-family: SourceHanSansCN-Medium;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 33px;
      letter-spacing: 2px;
      color: #006efd;
      text-align: center;
    }

  }
  &-row{
    width: 100%;
    margin-top: 51px;
    display: flex;
  }
}
.body-row{
  width: 952px;
  height: 51px;
  margin-top: 30px;
  background-color: #6cabfe;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  &-div{
    width: 147px;
    height: 38px;
    background-color: #a9cefe;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &-title{
    width: 860px;
    height: 15px;
    text-align: right;
    font-family: SourceHanSansCN-Normal;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #000000;
    position: relative;
    top:-35px
  }
  &-card{
    width: 952px;
    height: 343px;
    display: flex;
    &-left{
      width: 476px;
      margin-right: 5px;
      &-top{
        height: 230px;
        background-color: #e6f1ff;
        margin-bottom: 5px;
        padding-top: 9px;
        &-flex{
          width: calc(100% - 26px);
          margin-left: 9px;
          display: flex;
          flex-wrap: wrap;
          &-div{
            margin-top: 2px;
            width: 147px;
            height: 41px;
            background-color: #c8d6e8;
            display: flex;
            margin-left: 3px;
            align-items: center;
            justify-content: center;
            font-family: SourceHanSansCN-Normal;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #000000;
          }
        }
        &-title{
          width: 100%;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 15px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #000000;
        }
      }
      &-bottom{
        height: 108px;
        background-color: #eaeaea;
        display: flex;
      }
    }
    &-right{
      width: 476px;
      height: 352px;
      background-color: #e6f1ff;
      &-div{
        margin-top: 2px;
        width: 455px;
        height: 41px;
        background-color: #c8d6e8;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #000000;
      }
      &-title{
        width: 100%;
        height: 119px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 1px;
        color: #000000;
      }
    }
  }
}
.flex-center{
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-interval{
  margin-left: 142px;
}
.body-title{
  width: 245px;
  background-color: #006efd;
  padding:5px;
  margin-top: 97px;
  &-word{
    font-family: SourceHanSansCN-Medium;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    //line-height: 23px;
    letter-spacing: 2px;
    color: #ffffff;
  }
}
.body-dec{
  margin-top: 39px;
  width: 986px;
  font-family: SourceHanSansCN-Normal;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 1px;
  color: #333333;
}
.body-part{
  font-family: SourceHanSansCN-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 23px;
  letter-spacing: 2px;
  color: #333333;
}
.content{
  width: 100%;
  //margin: 0 auto;
  padding-top: 37px;
  padding-left: 16px;
  display: flex;
  //box-sizing: border-box;
  //display: flex;
  //justify-content: space-between;
  &>div{
    width: 167px;
    height: 212px;
    position: relative;
    .redBorder{
      position: absolute;
      z-index: 1;
      width: 134px;
      height: 136px;
      box-sizing: border-box;
      border: 9px solid #006efd;
      border-radius: 50%;
    }
    .whiteSpace{
      position: absolute;
      z-index: 2;
      width: 134px;
      height: 109px;
      background: #fff;
    }
    .text{
      position: absolute;
      z-index: 3;
      width: 134px;
      height: 126px;
      border:1px solid #e1e1e1;
      border-radius: 50%;
      border-bottom-color: #006efd;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      font-family: SourceHanSansCN-Normal;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      //line-height: 53px;
      letter-spacing: 2px;
      color: #333333;
    }
  }
}
.part-card-interval{
  margin-left: 64px;
}
.body-part-card{
  width: 100%;
  height: auto;
  padding-left: 15px;
  &-row{
    width: 100%;
    display: flex;
    &-card{
      width: 282px;
      height: 279px;
      background-color: #eeeeee;
      padding-top: 20px;
      &-top{
        margin-left: 24px;
        font-family: SourceHanSansCN-Medium;
        font-size: 15px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 23px;
        letter-spacing: 1px;
        color: #333333;
      }
      &-list{
        margin-top: 18px;
        margin-left: 15px;
        &-row{
          display: flex;
          align-items: center;
          height: 26px;
          &-round{
            font-family: SourceHanSansCN-Normal;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 26px;
            letter-spacing: 1px;
            color: #333333;
          }
          &-desc{
            margin-left: 4px;
            font-family: SourceHanSansCN-Normal;
            font-size: 15px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 26px;
            letter-spacing: 1px;
            color: #333333;
          }
        }
      }
    }
  }
}
.body-part-table{
  width: 976px;
  margin-top: 52px;
  padding: 0px 10px;
  td{
    height: 123px;
  }
  .left-title{
    width: 100%;
    height: 100%;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 2px;
    color: #006efd;
    background-color: #f3f3f3;
  }
  .right-title{
    width: 691px;
    height: 100%;
    background-color: #e6f1ff;
    font-family: SourceHanSansCN-Normal;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 1px;
    color: #333333;
  }
}
.flex-center-right{
  display: flex;
  align-items: center;
  padding-left: 41px;
}
.body-part-table-tr{
  width: 100%;
  display: flex;
  &-left{
    width: 131px;
    height: 238px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f3f3f3;
    font-family: SourceHanSansCN-Medium;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: 2px;
    color: #006efd;
  }
  &-right{
    height: 238px;
    position: relative;
    margin-left: 20px;
    &-td{
      width: 150px;
      height: 52px;
      background-color: #e6f1ff;
      font-family: SourceHanSansCN-Normal;
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 30px;
      letter-spacing: 1px;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 18px;
    }
  }
}
.right-clear{
  margin-right: 0px;
}
.sj-img-body{
  width: 100%;
  margin-top: 76px;
}
.gw-table{
  border: 3px solid #ffffff;
  margin-top: 66px ;
  &-title{
    background-color: #e6f1ff;
    font-family: SourceHanSansCN-Normal;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 2px;
    color: #333333;
    text-align: center;
  }
  &-td{
    height: 75px;
    background-color: #f3f3f3;
    font-family: SourceHanSansCN-Normal;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 24px;
    letter-spacing: 1px;
    color: #333333;
    &-left{
      padding-left: 36px;
    }
    &-right{
      padding-left: 12px;
    }
  }
}
.body-list-card{
  width: 100%;
  display: flex;
  .card-body{
    width: 171px;
    height: 52px;
    background-color: #e6f1ff;
    font-family: SourceHanSansCN-Normal;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .card-first{
    margin-left: 42px;
  }
  .card-other{
    margin-left: 19px;
  }
}
.low-title{
  margin-top: 42px;
  margin-left: 18px;
  font-family: SourceHanSansCN-Medium;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 23px;
  letter-spacing: 2px;
  color: #262626;
}
.low-desc{
  margin-top: 17px;
  margin-left: 18px;
  text-indent: 32px;
  font-family: SourceHanSansCN-Normal;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 1px;
  color: #333333;
}
.img-desc{
  width: 100%;
  height: 488px;
  margin-top: 47px;
  display: flex;
  .left{
    width: 3px;
    height: 100%;
    .ti{
      height: 95px;
      background: #006efd;
    }
  }
  .cont{
    width: 329px;
    height: 100%;
    .cont-list{
      width: 192px;
      margin-left: 90px;
      .desc-card{
        width: 100%;
        height: 50px;
        background-color: #ffffff;
        border: solid 1px #006efd;
        font-family: SourceHanSansCN-Normal;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 23px;
        letter-spacing: 2px;
        color: #006efd;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .desc-icon{
        width: 100%;
        height: 53px;
        transform: rotate(-90deg);
        font-family: SourceHanSansCN-Normal;
        font-size: 20px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 23px;
        letter-spacing: 2px;
        color: #006efd;
      }
    }
  }
  .right{
    width: 646px;
    height: 100%;
    background-image: linear-gradient(-90deg,
    #f1f7ff 0%,
    #ffffff 100%);
    .right-img{
      width: 100%;
      display: flex;
      .round{
        width: 102px;
        height: 102px;
        margin-left: 113px;
        background-color: #e9f2ff;
        border: solid 1px #006efd;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .right-desc{
      width: 100%;
      display: flex;
      .domain{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
        &-left{
          font-family: E-F7;
          font-size: 27px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 23px;
          letter-spacing: 2px;
          color: #006efd;
        }
        &-cont{
          width: 1px;
          height: 33px;
          background-color: #006efd;
          margin-left: 13px;
          margin-right: 12px;
        }
        &-right{
          width: 80px;
          font-family: SourceHanSansCN-Medium;
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          //line-height: 23px;
          letter-spacing: 1px;
          color: #006efd;
          white-space: nowrap;
        }
      }
    }
  }
}
.img-path{
  width: 986px;
  height: 201px;
  margin-top: 47px;
  background-image: linear-gradient(-90deg,
  #f1f8ff 0%,
  #d1e8ff 100%);
  .row{
    display: flex;
    padding-left: 86px;
    padding-top: 36px;
    .div{
      padding: 12px 6px;
      background: #354CFB;
      color: white;
      text-align: center;
      font-size: 12px;
      line-height: 20px;
      white-space: nowrap;
      border-radius: 10px;
    }
  }
  .desc1{
    height: 12px;
    padding: 12px 6px;
    background: #354CFB;
    color: white;
    text-align: center;
    font-size: 12px;
    line-height: 12px;
    white-space: nowrap;
    border-radius: 10px;
  }
  .img-cr{
    width: 842px;
    //height: 136px;
    margin-left: 20px;
    padding-top: 36px;
    display: flex;
    .desc{
      //height: auto;
      height: 30px;
      padding: 12px 6px;
      background: #354CFB;
      color: white;
      text-align: center;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      //line-height: 16px;
      white-space: nowrap;
      border-radius: 10px;
    }
    .point{
      //width: 30px;
      position: relative;
      //height: 400px;
      margin-top: 8px;
      font-size: 12px;
      text-align: center;
      margin-left: 3px;
      margin-right: 3px;
      .point-img{
        position: absolute;
      }
    }
    //.point{
    //  width: 30px;
    //  margin-left: 5px;
    //  display: flex;
    //  justify-content: center;
    //  align-items: center;
    //  .body{
    //    width: 12px;
    //    height: 10px;
    //    background: #354CFB;
    //  }
    //  .top{
    //    border: 8px solid transparent;
    //    border-left: 8px solid #354CFB;
    //    width: 0;
    //    height: 0px;
    //
    //  }
    //}
  }
}
.flex-lefts{
  width: 308px;
  height: 108px;
  margin-top: 12px;
  margin-left: 11px;
  &-div{
    width: 147px;
    height: 41px;
    background-color: #a9cefe;
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 1px;
    color: #000000;
  }
}
.flex-rights{
  width: 168px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #000000;
}
</style>